module.exports = __webpack_public_path__ + "img/tecniplast.96b7ba93.png";